import type { FunctionComponent } from 'react';

import { Spinner } from '@trello/nachos/spinner';

import * as styles from './AttachmentViewerSkeleton.module.less';

/**
 * Currently just a placeholder component with a background color that stands in
 * as a loading state for the attachment viewer.
 */
export const AttachmentViewerSkeleton: FunctionComponent = () => (
  <div className={styles.skeleton}>
    <Spinner centered wrapperClassName={styles.spinner} />
  </div>
);
